import { motion } from "framer-motion";

const STARS = Array.from({ length: 45 }, () => {
  const top = Math.random() * 100;
  const left = Math.random() * 100;
  return {
    id: `ph-${top.toFixed(3)}-${left.toFixed(3)}`,
    top, left,
    size: Math.random() * 2.4 + 1,
    delay: Math.random() * 4,
    duration: 3 + Math.random() * 4,
  };
});

export default function PageHero({ overline, sanskrit, title, subtitle, children }) {
  return (
    <div className="relative overflow-hidden" style={{ background: "#12103A", color: "white" }}>
      <div className="starfield" aria-hidden>
        {STARS.map((s) => (
          <span key={s.id} className="star" style={{
            top: `${s.top}%`, left: `${s.left}%`, width: `${s.size}px`, height: `${s.size}px`,
            animationDelay: `${s.delay}s`, animationDuration: `${s.duration}s`,
          }} />
        ))}
      </div>
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-20 lg:py-28 relative">
        <motion.div
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
        >
          {sanskrit && <div className="devanagari text-amber-300 text-sm mb-2">{sanskrit}</div>}
          {overline && <div className="overline" style={{ color: "#FCD34D" }}>{overline}</div>}
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl mt-3 leading-[1.05] max-w-4xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-5 text-stone-300 max-w-2xl text-lg leading-relaxed">{subtitle}</p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </motion.div>
      </div>
    </div>
  );
}
